<template>
  <div class="content">
    <Title :title="'流水记录'"></Title>
    <div class="topPlaceholder">
      <img src="@/assets/img/open/icon_news.png" alt="">
      <p>系统会在每天2：00将前一天结算佣金转至可提现账户中。您可前往账户中心进行提现。</p>
      <div class="withdrawBtn" @click="$router.push('/pc/user/accountWithdrawal')">
        <p>前往提现</p>
        <img src="@/assets/img/open/icon_arrow_red.png" alt="">
      </div>
    </div>
    <div class="record">
      <div class="recordStyle">
        <p>已结款金额</p>
        <div>{{ amountSettled }}元</div>
      </div>
      <div class="recordStyle">
        <p>待结款金额</p>
        <div>{{ balance }}元</div>
      </div>
    </div>
    <div class="search">
      <div class="flex">
        <p>订单号</p>
        <input type="text" placeholder="订单号" class="inputStyle" v-model="search.relation">
      </div>
      <div class="flex">
        <p>应用</p>
        <div class="status">
          <select class="statusSelect" v-model="search.applicationId">
            <option value="" label="全部"></option>
            <option value="1" label="肯德基"></option>
            <option value="3" label="电费充值"></option>
          </select>
        </div>
      </div>
      <div class="flex">
        <p>流水类型</p>
        <div class="status">
          <select class="statusSelect" v-model="search.type">
            <option value="" label="全部"></option>
            <option value="1" label="系统转款"></option>
            <option value="2" label="肯德基佣金结算"></option>
            <option value="4" label="电费佣金结算"></option>
          </select>
        </div>
      </div>
      <div class="flex">
        <p>选择时间</p>
        <DatePicker type="date" placeholder="开始时间" style="width: 150px;margin-right: 10px;margin-bottom: 8px;margin-top: 8px;"
          v-model="search.createTimeStartTime" @on-change="handelDateChangeStart"></DatePicker>
        <p>至</p>
        <DatePicker type="date" placeholder="结束时间" style="width: 150px;margin-bottom: 8px;margin-top: 8px;" v-model="search.createTimeEndTime"
          @on-change="handelDateChangeEnd"></DatePicker>
      </div>
      <div class="flex">
        <div class="searchBtn" @click="queryBtn">查询</div>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="listLoading" :data="tableData" style="width: 100%" :highlight-current-row="true"
        :header-cell-style="{background:'#FCFAF8',fontSize: '16px',fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi',fontWeight: 'normal',color: '#222222'}">
        <el-table-column label="序号" type="index" align="center" width="58" />
        <el-table-column label="流水号" prop="id" align="center" min-width="160px"></el-table-column>
        <el-table-column label="订单号" prop="relation" align="center" min-width="160px"></el-table-column>
        <el-table-column label="应用" prop="appName" align="center" min-width="135px"></el-table-column>
        <el-table-column label="流水类型" prop="typeStr" align="center" min-width="200px"></el-table-column>
        <el-table-column label="金额" prop="amount" align="center" min-width="140px"></el-table-column>
        <el-table-column label="结算时间" prop="createTimeStr" align="center" width="170px"></el-table-column>
      </el-table>
    </div>
    <div class="page">
      <Page v-if="total > 0" :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
        @on-page-size-change="changePagesize"></Page>
    </div>
  </div>
</template>

<script>
import Title from './components/title.vue'
import { DatePicker, Page } from 'view-design'
import { getRunningWater, getMoney } from '@/api/open.js'
import { getDate } from '@/utils/date'

export default {
  name: '',
  components: { Title, DatePicker, Page },
  props: {},
  data() {
    return {
      activeName: 'kfc',
      search: {
        type: '',
        applicationId: ''
      },
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      amountSettled: 0.0,
      totalIncome: 0.0,
      balance: 0.0,
      listLoading: false
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$store.getters.appKey.length === 0 && this.$store.getters.userToken !== '') {
      this.$message.warning('请先添加公众号')
      this.$router.push('/pc/open/application')
    }
    if (this.$store.getters.appKey.length > 0) {
      this.getList()
      this.getMoney()
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {
    getMoney() {
      getMoney({
        appKey: this.$store.getters.showAppKey.appKey
      }).then(res => {
        this.amountSettled = res.data.amountSettled
        this.totalIncome = res.data.totalIncome
        this.balance = res.data.balance
      })
    },
    getList() {
      this.listLoading = true
      let userParam = {
        createTimeEndTime: getDate(this.search.createTimeEndTime),
        createTimeStartTime: getDate(this.search.createTimeStartTime)
      }
      if (userParam.createTimeStartTime) {
        userParam.createTimeStartTime = userParam.createTimeStartTime + ' 00:00:00'
      } else {
        delete userParam.createTimeStartTime
      }
      if (userParam.createTimeEndTime) {
        userParam.createTimeEndTime = userParam.createTimeEndTime + ' 23:59:59'
      } else {
        delete userParam.createTimeEndTime
      }
      getRunningWater({
        ...userParam,
        appKey: this.$store.getters.showAppKey.appKey,
        relation: this.search.relation,
        type: this.search.type,
        applicationId: this.search.applicationId,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(res => {
        this.tableData = res.data.list
        if (res.data.pageNo === 0) {
          this.total = 0
          this.pageNo = 1
        } else {
          this.total = res.data.total
          this.pageNo = res.data.pageNo
          this.pageSize = res.data.pageSize
        }
        this.listLoading = false
      })
    },
    //查询
    queryBtn() {
      this.pageNo = 1
      console.log('search', this.search)
      this.getList()
    },
    handelDateChangeStart(time, type) {
      if (type == 'date') {
        if (this.search.timeEnd !== '') {
          if (this.compareTime(time, this.search.timeEnd)) {
            this.search.timeStart = this.search.timeEnd
          }
        }
      }
    },
    handelDateChangeEnd(time, type) {
      if (type == 'date') {
        if (this.search.timeStart !== '') {
          if (this.compareTime(this.search.timeStart, time)) {
            this.search.timeEnd = this.search.timeStart
          }
        }
      }
    },
    compareTime(startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    orderNumberStartBlur() {
      if (this.search.orderNumberEnd) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberStart = this.search.orderNumberEnd
        }
      }
    },
    orderNumberEndBlur() {
      if (this.search.orderNumberStart) {
        if (this.search.orderNumberStart > this.search.orderNumberEnd) {
          this.search.orderNumberEnd = this.search.orderNumberStart
        }
      }
    },
    changePage(value) {
      console.log(value)
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      console.log(value)
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.content {
  .topPlaceholder {
    display: flex;
    width: 100%;
    height: 40px;
    background-color: #fffbe6;
    border-radius: 4px;
    text-align: center;
    align-items: center;
    padding-left: 16px;
    margin-top: 10px;

    p {
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-left: 6px;
    }
    img {
      height: 20px;
      width: 20px;
    }
    .withdrawBtn {
      display: flex;
      align-items: center;
      cursor: pointer;
      p {
        color: #ff4f76;
      }
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
  .record {
    display: flex;
    align-items: center;
    padding-left: 30px;
    width: 100%;
    height: 93px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-top: 20px;

    .recordStyle {
      display: flex;
      align-items: center;
      margin-right: 66px;

      p {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        margin-right: 8px;
      }
      div {
        font-size: 24px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }
    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }
    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
    :hover {
      border-color: #57a3f3;
    }
    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
    .exportBtn {
      width: 90px;
      height: 32px;
      background: #fff;

      border: 1px solid #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: #ff8622;
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
    .statusSelect {
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 20px;
      padding-left: 10px;
      // padding-right: 10px;
    }
  }
  .table {
    border: 1px solid #eeeeee;
    margin-top: 30px;
    .status {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }
    .active0 {
      color: #ff4f76;
    }
    .active1 {
      color: #ff8622;
    }
  }
  .page {
    // margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flex {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/record.vue